import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleCallback } from '../config/auth';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateSession } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received.');
      return;
    }

    handleCallback(code)
      .then((session) => {
        updateSession(session);
        const returnTo = sessionStorage.getItem('auth_return_to') || '/marketplace';
        sessionStorage.removeItem('auth_return_to');
        navigate(returnTo, { replace: true });
      })
      .catch((err) => {
        setError(err.message || 'Authentication failed.');
      });
  }, [searchParams, navigate, updateSession]);

  if (error) {
    return (
      <div className="min-h-screen bg-page flex items-center justify-center">
        <div className="text-center space-y-4">
          <p className="text-red-400 font-semibold">Login failed</p>
          <p className="text-sm text-foreground-secondary">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-2 rounded-lg text-sm font-semibold transition-smooth"
            style={{ border: '1px solid rgba(249,115,22,0.4)', color: '#F97316' }}
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-page flex flex-col items-center justify-center gap-8">
      <img
        src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExMXdsOXo1aml2MjYzZzRwZ3h4amVvMG1waDdvamJsbGxzN3liNm9ncCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/U4FkC2VqpeNRHjTDQ5/giphy.gif"
        alt="Loading"
        className="w-48 h-48 rounded-2xl object-cover"
      />
      <div className="text-center space-y-2">
        <p className="text-lg font-semibold text-foreground-primary">Signing you in</p>
        <p className="text-sm text-foreground-muted">Hold tight, setting up your workspace...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
